export const StatusType = {
  IsPrimary: 'primary',
  IsSuccess: 'success',
  IsError: 'error',
  IsWarning: 'warning',
  IsPending: 'pending',
} as const;

export type StatusType = (typeof StatusType)[keyof typeof StatusType];
